/** Display version, e.g. "1.0" for package.json 1.0.0 (patch shown only when non-zero). */
export const APP_VERSION = __APP_VERSION__.replace(/\.0$/, '');
